import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../../examples/Navbars/DashboardNavbar";
import CrudService from "services/cruds-service";
import "jspdf-autotable";
import Footer from "../../../../../../examples/Footer";
import countryOptions from "../../components/List/Countries";
import MenuItem from "@mui/material/MenuItem";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Tabs, Tab } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, FormControlLabel, IconButton } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import Checkbox from "@mui/material/Checkbox";
import { AddRowButton, RemoveRowButton } from "components/RowActions";
import { ReadOnlyBanner, ReadOnlyFieldset } from "components/ReadOnlyLock";

// isModal: rendered inside another page's dialog (e.g. "+ New Account" on the OMBL agent fields);
// the new agent is handed back through onCreated instead of navigating away.
const CreateGlobalAgent = ({ isModal = false, onClose, onCreated } = {}) => {
    const navigate = useNavigate();
    const [formError, setFormError] = useState("");

    const globalAgentOptions = [
        { label: "Sole Proprietorship" },
        { label: "General Partnership" },
        { label: "Limited Partnership" },
        { label: "Limited Liability Company (LLC)" },
        { label: "Joint Stock Company / Corporation (Inc.)" },
        { label: "Limited Liability Partnership (LLP)" },
        { label: "Cooperative" },
        { label: "Nonprofit Association" },
        { label: "Foundation" },
        { label: "Joint Venture" },
        { label: "Holding Company" },
        { label: "Branch Office" },
        { label: "Representative Office" },
        { label: "Franchise" },
    ];

    const industriesOptions = [
        { label: "Automotive & Spare Parts" },
        { label: "Consumer Electronics" },
        { label: "Pharmaceuticals & Medical Devices" },
        { label: "Industrial Machinery & Equipment" },
        { label: "FMCG (Fast Moving Consumer Goods)" },
        { label: "Textiles & Apparel" },
        { label: "Chemicals & Hazardous Materials" },
        { label: "Oil & Energy" },
        { label: "Food & Beverage (Dry / Reefer)" },
        { label: "Construction Materials" },
        { label: "E-commerce & Retail" },
        { label: "Agricultural Products & Inputs" },
        { label: "Metals & Raw Materials" },
        { label: "Aerospace & Aviation Parts" },
        { label: "Plastic, Rubber & Packaging" },
    ];

    const [formData, setFormData] = useState({
        name: "",
        globalAgentCountry: "",
        salesRep: "",
        taxID: "",
        taxOffice: "",
        globalAgentTypes: "",
        billingAddress: "",
        phone: "",
        email: "",
        website: "",
        representatives: "",
        paymentTerms: "",
        creditLimit: "",
        currency: "",
        iban: "",
        pricingRepresentatives:"",
        financeRepresentatives: "",
        operationRepresentatives:"",
        contactPersonName: "",
        contactPersonTitle: "",
        contactPersonInfo: "",
        globalAgentCategory: "",
        globalAgentStatus: "",
        serviceType: "",
        globalAgentNo: "",
        shippingPreferences: "",
        specialNotes: "",
        transactionNotes: "",
        complaintHistory: "",
        servicesCountry:"",
        servicesPriority:"",
        verticalIndustry:""
    });
    const [loading, setLoading] = useState(false); // Yüklenme durumu
    const [isEditing, setIsEditing] = useState(false); // Düzenleme modu
    const searchParams = new URLSearchParams(location.search); // Query parametrelerini yakalıyoruz
    // In a dialog the page URL belongs to the host page (its ?id= is not a global agent).
    const globalAgentId = isModal ? null : searchParams.get("id"); // URL'deki `id` parametresini alıyoruz
    // An existing global partner opens read-only, like the TMS pages; "Edit" unlocks the form.
    const [readOnlyMode, setReadOnlyMode] = useState(Boolean(globalAgentId));
    const [successMessage, setSuccessMessage] = useState("");
    const successMessageRef = useRef(null); // Ref oluşturuldu
    const [warningMessage, setWarningMessage] = useState("");
    const warningRef = useRef(null);
    const [externalCompanyId, setExternalCompanyId] = useState(null);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [companyLoading, setCompanyLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const handleSnackbarClose = (_, reason) => {
        if (reason === "clickaway") return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map(user => ({
                    id: user.id,
                    label: user.attributes.name
                }));

                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        };

        fetchSalesReps();
    }, []);


    // Eğer globalAgentId varsa düzenleme modundayız ve veriyi çekiyoruz
    useEffect(() => {
        if (globalAgentId) {
            setIsEditing(true); // Düzenleme modunu etkinleştiriyoruz
            fetchGlobalAgentDetails(globalAgentId); // globalAgent detaylarını çekiyoruz
        }
        setReadOnlyMode(Boolean(globalAgentId));
    }, [globalAgentId]);

    const fetchGlobalAgentDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getGlobalAgentById(id);
            const globalAgentData = response.data.attributes || {};

            const normalizeArray = (field) =>
                Array.isArray(field) ? field : field ? [field] : [];

            const normalizeRepresentatives = (field) => {
                const normalizeDepartment = (dep) =>
                    Array.isArray(dep) ? dep : dep ? [dep] : [];

                if (!field || (typeof field === "string" && field.trim() === "")) {
                    return [{
                        name: "",
                        phone: "",
                        email: "",
                        title: "",
                        department: [],
                        country: "",
                        city: ""
                    }];
                }

                if (Array.isArray(field) && field.length === 0) {
                    return [{
                        name: "",
                        phone: "",
                        email: "",
                        title: "",
                        department: [],
                        country: "",
                        city: ""
                    }];
                }

                if (Array.isArray(field)) {
                    return field.map((rep) => ({
                        name: rep?.name || "",
                        phone: rep?.phone || "",
                        email: rep?.email || "",
                        title: rep?.title || "",
                        department: normalizeDepartment(rep?.department),
                        country: rep?.country || "",
                        city: rep?.city || "",
                    }));
                }

                if (typeof field === "object") {
                    return [{
                        name: field.name || "",
                        phone: field.phone || "",
                        email: field.email || "",
                        title: field.title || "",
                        department: normalizeDepartment(field.department),
                        country: field.country || "",
                        city: field.city || "",
                    }];
                }

                return [{
                    name: "",
                    phone: "",
                    email: "",
                    title: "",
                    department: [],
                    country: "",
                    city: ""
                }];
            };

            // ✅ normalize edilmiş listeleri bir kere üretelim (hem setState’te kullanırız hem preload’da)
            const repsNormalized = normalizeRepresentatives(globalAgentData.representatives);
            const pricingRepsNormalized = normalizeRepresentatives(globalAgentData.pricingRepresentatives);
            const financeRepsNormalized = normalizeRepresentatives(globalAgentData.financeRepresentatives);
            const operationRepsNormalized = normalizeRepresentatives(globalAgentData.operationRepresentatives);
            const financialBlocks =
                Array.isArray(globalAgentData.financialInfoByProduct) &&
                globalAgentData.financialInfoByProduct.length > 0
                    ? globalAgentData.financialInfoByProduct.map((b) => ({
                        ...defaultFinancialBlock,
                        ...b,
                        financialTerms: {
                            road: b.financialTerms?.road || {
                                paymentTerms: b.paymentTerms || 0,
                                creditLimit: b.creditLimit || 0,
                                currency: b.currency || "USD",
                            },
                            ocean: b.financialTerms?.ocean || {
                                paymentTerms: 0,
                                creditLimit: 0,
                                currency: "USD",
                            },
                            air: b.financialTerms?.air || {
                                paymentTerms: 0,
                                creditLimit: 0,
                                currency: "USD",
                            },
                        },
                        bankDetails: b.bankDetails?.length
                            ? b.bankDetails
                            : [
                                {
                                    bankName: "",
                                    swiftCode: "",
                                    iban: b.iban || "",
                                    currency: b.currency || "USD",
                                },
                            ],
                    }))
                    : [{ ...defaultFinancialBlock }];

            setFinancialInfoByProduct(financialBlocks);

            const primary = financialBlocks[0] || defaultFinancialBlock;
            setPaymentTerms(primary.paymentTerms);
            setCreditLimit(primary.creditLimit);
            setCurrency(primary.currency);
            setIban(primary.iban);

            // 🔹 Basit alanlar
            setName(globalAgentData.name || "");
            setGlobalAgentCountry(globalAgentData.globalAgentCountry || "");
            setTaxID(globalAgentData.taxID || "");
            setTaxOffice(globalAgentData.taxOffice || "");
            setGlobalAgentTypes(globalAgentData.globalAgentTypes || "");
            setBillingAddress(globalAgentData.billingAddress || "");
            setPhone(globalAgentData.phone || "");
            setEmail(globalAgentData.email || "");
            setWebsite(globalAgentData.website || "");
            setContactPersonName(globalAgentData.contactPersonName || "");
            setContactPersonTitle(globalAgentData.contactPersonTitle || "");
            setContactPersonInfo(globalAgentData.contactPersonInfo || "");
            setGlobalAgentCategory(globalAgentData.globalAgentCategory ?? 0);
            setGlobalAgentStatus(globalAgentData.globalAgentStatus || "");
            setGlobalAgentNo(globalAgentData.globalAgentNo || "");
            setSpecialNotes(globalAgentData.specialNotes || "");
            setTransactionNotes(globalAgentData.transactionNotes || "");
            setComplaintHistory(globalAgentData.complaintHistory || "");

            // 🔹 Dizi formatlı alanlar
            setServiceType(normalizeArray(globalAgentData.serviceType));
            setShippingPreferences(normalizeArray(globalAgentData.shippingPreferences));
            setServicesCountry(normalizeArray(globalAgentData.servicesCountry));
            setServicesPriority(normalizeArray(globalAgentData.servicesPriority));
            setVerticalIndustry(normalizeArray(globalAgentData.verticalIndustry));
            setByGeneralLocationAndCoverage(normalizeArray(globalAgentData.byGeneralLocationAndCoverage));
            setByServiceExpertise(normalizeArray(globalAgentData.byServiceExpertise));
            setSectorFocusedGroups(normalizeArray(globalAgentData.sectorFocusedGroups));
            setByTypeOfCollaboration(normalizeArray(globalAgentData.byTypeOfCollaboration));

            // 🔹 Representatives set
            setRepresentatives(repsNormalized);
            setPricingRepresentatives(pricingRepsNormalized);
            setFinanceRepresentatives(financeRepsNormalized);
            setOperationRepresentatives(operationRepsNormalized);

            // 🔹 SalesRep eşitlemesi
            setSalesRep(
                Array.isArray(globalAgentData.salesRep)
                    ? salesRepOptions.filter((rep) => globalAgentData.salesRep.includes(rep.id))
                    : []
            );
            const refs = globalAgentData.references || {};

            setReferenceSource(refs.source || "");

            if (refs.source === "Sales Team") {
                setReferencePerson(refs.salesTeamPerson || "");
            }

            if (refs.source === "Management") {
                setReferencePerson(refs.managementPerson || "");
                setIsHouseAccountRef(!!refs.managementHouseAccount);
            }

            if (refs.source === "External") {
                setExternalType(refs.externalType || "");
                setExternalPersonName(refs.externalPersonFullName || "");
            }

            if (refs.source === "External" && refs.externalType === "Company") {
                setExternalCompanyId(refs.externalCompany ? String(refs.externalCompany) : null);
            }
            // 🔹 Form datası güncelle
            setFormData({
                name: globalAgentData.name || "",
                globalAgentCountry: globalAgentData.globalAgentCountry || "",
                salesRep: globalAgentData.salesRep || [],
                globalAgentTypes: globalAgentData.globalAgentTypes || "",
                taxID: globalAgentData.taxID || "",
                taxOffice: globalAgentData.taxOffice || "",
                billingAddress: globalAgentData.billingAddress || "",
                phone: globalAgentData.phone || "",
                email: globalAgentData.email || "",
                website: globalAgentData.website || "",
                representatives: repsNormalized,
                paymentTerms: globalAgentData.paymentTerms ?? "",
                creditLimit: globalAgentData.creditLimit ?? "",
                currency: globalAgentData.currency || "",
                iban: globalAgentData.iban || "",
                pricingRepresentatives: pricingRepsNormalized,
                financeRepresentatives: financeRepsNormalized,
                operationRepresentatives: operationRepsNormalized,
                contactPersonName: globalAgentData.contactPersonName || "",
                contactPersonTitle: globalAgentData.contactPersonTitle || "",
                contactPersonInfo: globalAgentData.contactPersonInfo || "",
                globalAgentCategory: globalAgentData.globalAgentCategory ?? "",
                globalAgentStatus: globalAgentData.globalAgentStatus || "",
                serviceType: normalizeArray(globalAgentData.serviceType),
                globalAgentNo: globalAgentData.globalAgentNo || "",
                shippingPreferences: normalizeArray(globalAgentData.shippingPreferences),
                specialNotes: globalAgentData.specialNotes || "",
                complaintHistory: globalAgentData.complaintHistory || "",
                servicesCountry: normalizeArray(globalAgentData.servicesCountry),
                servicesPriority: normalizeArray(globalAgentData.servicesPriority),
                verticalIndustry: normalizeArray(globalAgentData.verticalIndustry),
            });

            // ✅✅ EDIT MODU CITY PRELOAD: country doluysa şehirleri otomatik cache’e çek
            const countriesToPreload = [
                ...repsNormalized.map((r) => r.country).filter(Boolean),
                ...pricingRepsNormalized.map((r) => r.country).filter(Boolean),
                ...financeRepsNormalized.map((r) => r.country).filter(Boolean),
                ...operationRepsNormalized.map((r) => r.country).filter(Boolean),
            ];

            const uniqueCountries = Array.from(new Set(countriesToPreload));
            await Promise.all(uniqueCountries.map((c) => ensureCitiesLoaded(c)));

        } catch (error) {
            console.error("Error fetching globalAgent details:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (globalAgentId && salesRepOptions.length > 0) {
            setIsEditing(true);
            fetchGlobalAgentDetails(globalAgentId);
        }
    }, [globalAgentId, salesRepOptions]);

    useEffect(() => {
        if (!externalCompanyId || !companyOptions.length) return;

        const found = companyOptions.find(
            (o) => String(o.value) === String(externalCompanyId)
        );

        if (found) {
            setExternalCompany(found);
        }
    }, [externalCompanyId, companyOptions]);

    const addBankDetail = (financeIndex) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];
            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails: [
                    ...(updated[financeIndex].bankDetails || []),
                    { bankName: "", swiftCode: "", iban: "", currency: "USD" },
                ],
            };
            return updated;
        });
    };

    const removeBankDetail = (financeIndex, bankIndex) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];
            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails: updated[financeIndex].bankDetails.filter((_, i) => i !== bankIndex),
            };
            return updated;
        });
    };

    const updateBankDetail = (financeIndex, bankIndex, field, value) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];
            const bankDetails = [...(updated[financeIndex].bankDetails || [])];

            bankDetails[bankIndex] = {
                ...bankDetails[bankIndex],
                [field]: value,
            };

            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails,
            };

            return updated;
        });
    };

    const [salesRep, setSalesRep] = useState([]);
    const [name, setName] = useState("");
    const [globalAgentCountry, setGlobalAgentCountry] = useState("");
    const [taxID, setTaxID] = useState("");
    const [taxOffice, setTaxOffice] = useState("");
    const [globalAgentTypes, setGlobalAgentTypes] = useState("");
    const [billingAddress, setBillingAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [pricingRepresentatives, setPricingRepresentatives] = useState([{ name: "", phone:"", email:"", title: "", department:[], country:"", city:""}]);
    const [representatives, setRepresentatives] = useState([{ name: "", phone:"", email:"", title: "", department:[], country:"", city:""}]);
    const [paymentTerms, setPaymentTerms] = useState(0);
    const [creditLimit, setCreditLimit] = useState(0);
    const [currency, setCurrency] = useState("");
    const [iban, setIban] = useState('');
    const [financeRepresentatives, setFinanceRepresentatives] = useState([{name: "", phone:"", email:"", title: "", department:[], country:"", city:"" }]);
    const [operationRepresentatives, setOperationRepresentatives] = useState([{name: "", phone:"", email:"", title: "", department:[], country:"", city:"" }]);
    const [contactPersonName, setContactPersonName] = useState('');
    const [contactPersonTitle, setContactPersonTitle] = useState('');
    const [contactPersonInfo, setContactPersonInfo] = useState('');
    const [globalAgentCategory, setGlobalAgentCategory] = useState(0);
    const [globalAgentStatus, setGlobalAgentStatus] = useState('');
    const [serviceType, setServiceType] = useState([]);
    const [globalAgentNo, setGlobalAgentNo] = useState('');
    const [shippingPreferences, setShippingPreferences] = useState([]);
    const [specialNotes, setSpecialNotes] = useState('');
    const [transactionNotes, setTransactionNotes] = useState('');
    const [complaintHistory, setComplaintHistory] = useState('');
    const [servicesCountry, setServicesCountry] = useState([]);
    const [servicesPriority, setServicesPriority] = useState([]);
    const [verticalIndustry, setVerticalIndustry] = useState([]);
    const [byGeneralLocationAndCoverage, setByGeneralLocationAndCoverage] = useState([]);
    const [byServiceExpertise, setByServiceExpertise] = useState([]);
    const [sectorFocusedGroups, setSectorFocusedGroups] = useState([]);
    const [byTypeOfCollaboration, setByTypeOfCollaboration] = useState([]);
    const [referenceSource, setReferenceSource] = useState("");
    const [referencePerson, setReferencePerson] = useState("");
    const [isHouseAccountRef, setIsHouseAccountRef] = useState(false);
    const [externalType, setExternalType] = useState("");
    const [externalPersonName, setExternalPersonName] = useState("");
    const [externalForwardTo, setExternalForwardTo] = useState(null);
    const [externalCompany, setExternalCompany] = useState(null);


    const salesTeamPeople = ["Ali Kaya Koç", "Emre Akbıyık", "Hamdi Gülşen"];

    const managementPeople = [
        "Olcay Gülşen",
        "Sedat Gökmen",
        "Mehmet İkmaz",
        "Emin Kaydu",
        "Beyhan Özgün",
    ];
    const defaultFinancialTerms = {
        road: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
        ocean: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
        air: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
    };

    const defaultFinancialBlock = {
        id: Date.now(),
        financialTerms: defaultFinancialTerms,
        dateType: "Invoice Date",
        bankDetails: [
            {
                bankName: "",
                swiftCode: "",
                iban: "",
                currency: "USD",
            },
        ],
    };

    const [financialInfoByProduct, setFinancialInfoByProduct] = useState([
        { ...defaultFinancialBlock },
    ]);

    const departmentOptions = [
        "Management",
        "Ocean",
        "Air",
        "Project",
        "Road",
        "Sales",
        "Pricing",
        "Finance",
    ];

    // Country -> [ "Istanbul", "Ankara", ... ]
    const [repCityOptionsMap, setRepCityOptionsMap] = useState({});
    const [repCityLoadingMap, setRepCityLoadingMap] = useState({}); // Country -> boolean

    useEffect(() => {
        const fetchCompanies = async () => {
            setCompanyLoading(true);

            try {
                const res = await CrudService.getCustomers();
                const raw = res?.data?.data || res?.data || [];

                const normalized = raw
                    .map((item) => {
                        const id = item?.id || item?._id || item?.attributes?._id;
                        const name = item?.attributes?.name || item?.name;

                        if (!name) return null;

                        return {
                            label: String(name).toUpperCase(),
                            value: id || String(name),
                        };
                    })
                    .filter(Boolean);

                const uniq = Array.from(
                    new Map(normalized.map((x) => [x.label, x])).values()
                );

                setCompanyOptions(uniq);
            } catch (error) {
                console.error("Company list fetch error:", error);
                setCompanyOptions([]);
            } finally {
                setCompanyLoading(false);
            }
        };

        fetchCompanies();
    }, []);
    const ensureCitiesLoaded = async (countryLabel) => {
        if (!countryLabel) return;

        // cache varsa tekrar çekme
        if (repCityOptionsMap[countryLabel]?.length) return;
        if (repCityLoadingMap[countryLabel]) return;

        try {
            setRepCityLoadingMap((p) => ({ ...p, [countryLabel]: true }));

            // ✅ Burayı senin backend methoduna göre uyarlayacaksın:
            // Örn: CrudService.getCitiesByCountry(countryLabel)
            const res = await CrudService.getCitiesByCountry(countryLabel);

            // res.data: ["Istanbul", ...] gibi bekliyorum
            const cities = Array.isArray(res?.data) ? res.data : [];

            setRepCityOptionsMap((p) => ({ ...p, [countryLabel]: cities }));
        } catch (e) {
            console.error("Cities fetch error:", e);
            setRepCityOptionsMap((p) => ({ ...p, [countryLabel]: [] }));
        } finally {
            setRepCityLoadingMap((p) => ({ ...p, [countryLabel]: false }));
        }
    };


    const submitHandler = async (e) => {
        e.preventDefault();
        // 🔹 Zorunlu alan kontrolü
        if (!name.trim() || !globalAgentCountry.trim()) {
            setFormError("⚠️ Please fill in all required fields: Global Partner Name and Country.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        setFormError("");
        const primaryBlock = financialInfoByProduct[0] || defaultFinancialBlock;

        const globalAgentData = {
            name,
            globalAgentCountry,
            salesRep: salesRep.map(r => r.id).filter(Boolean),
            taxID,
            taxOffice,
            globalAgentTypes,
            billingAddress,
            phone,
            email,
            website,
            representatives,
            financialInfoByProduct,
            pricingRepresentatives,
            financeRepresentatives,
            operationRepresentatives,
            contactPersonName,
            contactPersonTitle,
            contactPersonInfo,
            globalAgentCategory,
            globalAgentStatus,
            serviceType,
            shippingPreferences,
            specialNotes,
            transactionNotes,
            complaintHistory,
            servicesCountry,
            servicesPriority,
            verticalIndustry,
            byGeneralLocationAndCoverage,
            byServiceExpertise,
            sectorFocusedGroups,
            byTypeOfCollaboration,
            references: {
                source: referenceSource,
                salesTeamPerson: referenceSource === "Sales Team" ? referencePerson || null : null,
                managementPerson: referenceSource === "Management" ? referencePerson || null : null,
                managementHouseAccount: referenceSource === "Management" ? !!isHouseAccountRef : false,
                externalType: referenceSource === "External" ? externalType : null,
                externalPersonFullName:
                    referenceSource === "External" && externalType === "In Person"
                        ? externalPersonName || null
                        : null,
                externalForwardToSalesRep:
                    referenceSource === "External" && externalType === "In Person"
                        ? externalForwardTo?.id || null
                        : null,
                externalCompany:
                    referenceSource === "External" && externalType === "Company"
                        ? externalCompany?.value || null
                        : null,
            },
        };
        try {
            setLoading(true);

            let response;
            if (isEditing) {
                await CrudService.updateGlobalAgent(globalAgentData, globalAgentId);
                setSnackbar({
                    open: true,
                    message: "Global Partner updated successfully.",
                    severity: "success",
                });
            } else {
                response = await CrudService.createGlobalAgent({ data: globalAgentData });
                setSnackbar({
                    open: true,
                    message: "Global Partner created successfully.",
                    severity: "success",
                });

                if (isModal) {
                    onCreated?.(response?.data?.data || response?.data || null);
                    onClose?.();
                    return;
                }
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            setTimeout(() => {
                navigate("/global-agent/global-agent-tables/details");
            }, 3000);
        } catch (err) {
            if (err.response?.status === 409) {
                setSnackbar({
                    open: true,
                    message: "This Global Partner already exists.",
                    severity: "error",
                });
                return;
            }

            setSnackbar({
                open: true,
                message: "This Global Partner already exists.",
                severity: "error",
            });
        }
        finally {
            setLoading(false);
        }
    };


    // Yeni Representative ekleyen fonksiyon
    const addRepresentative = () => {
        setRepresentatives([...representatives, { name: "", phone:"", email:"", title: "", department:[], country:"", city:""}]);
    };

    // Belirli bir Representative'ı kaldıran fonksiyon
    const removeRepresentative = (index) => {
        const updatedReps = [...representatives];
        updatedReps.splice(index, 1); // Index'e göre sil
        setRepresentatives(updatedReps);
    };

    // Temsilci alanındaki input'u güncelleyen fonksiyon
    const updateRepresentative = (index, field, value) => {
        const updatedReps = [...representatives];
        updatedReps[index][field] = value;
        setRepresentatives(updatedReps);
    };


    const addPricingRepresentative = () => {
        setPricingRepresentatives([...pricingRepresentatives, { name: "", phone:"", email:"", title: "", department:[], country:"", city:""}]);
    };


    const removePricingRepresentative = (index) => {
        const updatedReps = [...pricingRepresentatives];
        updatedReps.splice(index, 1);
        setPricingRepresentatives(updatedReps);
    };

    const updatePricingRepresentative = (index, field, value) => {
        const updatedReps = [...pricingRepresentatives];
        updatedReps[index][field] = value;
        setPricingRepresentatives(updatedReps);
    };

    const addOperationRepresentative = () => {
        setOperationRepresentatives([...operationRepresentatives, { name: "", phone:"", email:"", title: "", department:[], country:"", city:""}]);
    };


    const removeOperationRepresentative = (index) => {
        const updatedReps = [...operationRepresentatives];
        updatedReps.splice(index, 1);
        setOperationRepresentatives(updatedReps);
    };

    const updateOperationRepresentative = (index, field, value) => {
        const updatedReps = [...operationRepresentatives];
        updatedReps[index][field] = value;
        setOperationRepresentatives(updatedReps);
    };



    // Yeni Finance Representative ekleyen fonksiyon
    const addFinanceRepresentative = () => {
        setFinanceRepresentatives([...financeRepresentatives, { name: "", phone:"", email:"", title: "", department:[], country:"", city:"" }]);
    };

    // Belirli bir Finance Representative'ı kaldıran fonksiyon
    const removeFinanceRepresentative = (index) => {
        const updatedReps = [...financeRepresentatives];
        updatedReps.splice(index, 1); // İlgili index'i sil
        setFinanceRepresentatives(updatedReps);
    };

    // Finance Representative alanını güncelleyen fonksiyon
    const updateFinanceRepresentative = (index, field, value) => {
        const updatedReps = [...financeRepresentatives];
        updatedReps[index][field] = value; // Belirli alanı güncelle
        setFinanceRepresentatives(updatedReps);
    };


    const updateFinancialTerm = (financeIndex, mode, field, value) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];
            const currentBlock = updated[financeIndex] || {};

            const currentFinancialTerms = {
                ...defaultFinancialTerms,
                ...(currentBlock.financialTerms || {}),
            };

            updated[financeIndex] = {
                ...currentBlock,
                financialTerms: {
                    ...currentFinancialTerms,
                    [mode]: {
                        ...defaultFinancialTerms[mode],
                        ...(currentFinancialTerms[mode] || {}),
                        [field]: value,
                    },
                },
            };

            return updated;
        });
    };


    const handlePaymentChange = (event) => {
        let value = event.target.value;
        let numValue = value === "" ? "" : Math.max(0, Math.min(120, Number(value)));

        setPaymentTerms(numValue);

        if (numValue > 45) {
            setWarningMessage("⚠️ For payment terms over 45 days, please contact your manager");
        } else {
            setWarningMessage("");
        }
    };

    const handleCreditChange = (event) => {
        let value = event.target.value;
        let numValue = value === "" ? "" : Math.max(0, Math.min(200000, Number(value)));
        setCreditLimit(numValue);
    };


    const formContent = (
        <>

            {/* Warning Message */}
            {warningMessage && (
                <div
                    ref={warningRef}
                    style={{
                        position: "sticky",
                        top: 100,
                        zIndex: 999,
                        backgroundColor: "#f9c74f",
                        color: "#000000",
                        padding: "12px",
                        textAlign: "center",
                        marginBottom: "15px",
                        borderRadius: "5px",
                        fontWeight: "bold",
                        boxShadow: "none",
                    }}
                >
                    {warningMessage}
                </div>
            )}

            {/* Başarı Mesajı */}
            <MDBox mb={2}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12} textAlign="center">
                        <div
                            ref={successMessageRef}
                            style={{
                                backgroundColor: successMessage ? "#ECFDF3" : "transparent",
                                color: successMessage ? "#027A48" : "transparent",
                                border: successMessage ? "1px solid #ABEFC6" : "none",
                                fontWeight: 600,
                                padding: "10px",
                                marginBottom: "10px",
                                borderRadius: "5px",
                                visibility: successMessage ? "visible" : "hidden",
                            }}
                        >
                            {successMessage}
                        </div>

                        <MDTypography variant="h3" fontWeight="bold">
                            {isEditing
                                ? "Edit Global Partner Card Details"
                                : "Add Global Partner Card Details"}
                        </MDTypography>

                        <MDTypography variant="h5" fontWeight="regular" color="secondary">
                            This information will give you more information about the Global Partner Card.
                        </MDTypography>

                        {formError && (
                            <div
                                style={{
                                    backgroundColor: "#ffb3b3",
                                    color: "#b30000",
                                    padding: "10px",
                                    marginTop: "15px",
                                    borderRadius: "6px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    boxShadow: "none",
                                }}
                            >
                                {formError}
                            </div>
                        )}
                    </Grid>
                </Grid>
            </MDBox>

            {readOnlyMode && (
                <ReadOnlyBanner
                    message="This global partner is in read-only view. Click Edit to make changes."
                    onEdit={() => setReadOnlyMode(false)}
                />
            )}

            {/* Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 3 }}>
                <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)} centered>
                    <Tab label="General Information" />
                    <Tab label="Contact List" />
                </Tabs>
            </Box>

            <ReadOnlyFieldset readOnly={readOnlyMode}>
            <MDBox
                sx={{
                    mt:2,
                    p: 3,
                    borderRadius: "10px",
                    bgcolor: "background.paper",
                    boxShadow: "none",
                }}
            >
                {/* -------------------- TAB 0 BAŞLANGICI -------------------- */}
                {activeTab === 0 && (
                    <>
                        <MDBox mt={1}>
                            <MDTypography variant="h6">Basic Information</MDTypography>
                        </MDBox>

                        <MDBox mt={3}>
                            <Grid container spacing={3}>

                                {/* Global Partner Name */}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        type="text"
                                        label="Global Partner Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": { height: 56 }
                                        }}
                                    />
                                </Grid>

                                {/* Global Partner Country */}
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        fullWidth
                                        options={countryOptions}
                                        getOptionLabel={(o) => o.label}
                                        value={globalAgentCountry ? { label: globalAgentCountry } : null}
                                        onChange={(event, newValue) =>
                                            setGlobalAgentCountry(newValue ? newValue.label : "")
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Select Headquarters of the Global Partner Country"
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: 56,
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Service Countries - Multiple */}
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        fullWidth
                                        multiple
                                        options={countryOptions}
                                        getOptionLabel={(o) => o.label}
                                        value={servicesCountry.map((label) => {
                                            const match = countryOptions.find((c) => c.label === label);
                                            return match || { label };
                                        })}
                                        onChange={(e, newValue) =>
                                            setServicesCountry(newValue.map((o) => o.label))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Service Countries"
                                            />
                                        )}
                                    />
                                </Grid>


                            </Grid>
                        </MDBox>

                        {/* -------------------- OPERATIONAL INFORMATION -------------------- */}
                        <MDBox mt={5}>
                            <MDTypography variant="h6">Operational Information</MDTypography>

                            <Grid container spacing={2} alignItems="center" mt={1}>

                                {/* Category */}
                                <Grid item xs={12} sm={2}>
                                    <MDTypography fontSize={15}>Global Partner Category</MDTypography>
                                    {[1,2,3,4,5].map((star) => (
                                        <span
                                            key={star}
                                            onClick={() => setGlobalAgentCategory(star)}
                                            style={{
                                                cursor: "pointer",
                                                color: star <= globalAgentCategory ? "#FFD700" : "#CCC",
                                                fontSize: "24px",
                                                marginRight: 4
                                            }}
                                        >
          ★
        </span>
                                    ))}
                                </Grid>

                                {/* Status */}
                                <Grid item xs={12} sm={2}>
                                    <Autocomplete
                                        options={[
                                            { label: "Pending Review", value: "Pending Review" },
                                            { label: "Active", value: "Active" },
                                            { label: "De-Active", value: "De-Active" },
                                            { label: "Prospect", value: "Prospect" },
                                        ]}
                                        value={[
                                            { label: "Pending Review", value: "Pending Review" },
                                            { label: "Active", value: "Active" },
                                            { label: "De-Active", value: "De-Active" },
                                            { label: "Prospect", value: "Prospect" },
                                        ].find((o) => o.value === globalAgentStatus) || null}
                                        getOptionLabel={(o) => o.label}
                                        onChange={(e, v) => setGlobalAgentStatus(v?.value || "")}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Status"
                                                fullWidth
                                                sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Services Priority */}
                                <Grid item xs={12} sm={2}>
                                    <Autocomplete
                                        multiple
                                        options={[
                                            { label: "Road", value: "Road" },
                                            { label: "Ocean", value: "Ocean" },
                                            { label: "Air", value: "Air" },
                                            { label: "Project Cargo", value: "Project Cargo" },
                                            { label: "Intermodal", value: "Intermodal" },
                                            { label: "Customs and Compliance", value: "Customs and Compliance" },
                                        ]}
                                        value={servicesPriority.map((x) => ({ label: x, value: x }))}
                                        getOptionLabel={(o) => o.label}
                                        onChange={(e, v) => setServicesPriority(v.map((i) => i.value))}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Services Priority"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Industries */}
                                <Grid item xs={12} sm={4}>
                                    <Autocomplete
                                        multiple
                                        options={industriesOptions}
                                        value={industriesOptions.filter((x) => verticalIndustry.includes(x.label))}
                                        getOptionLabel={(o) => o.label}
                                        onChange={(e, v) => setVerticalIndustry(v.map((i) => i.label))}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Industries"
                                                fullWidth
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        minHeight: 56,        // ✅ sabit değil, esnek
                                                        alignItems: "flex-start",
                                                        paddingTop: "8px",
                                                        paddingBottom: "8px",
                                                    },
                                                }}                                            />
                                        )}
                                    />
                                </Grid>
                                {/* Global Partner ID */}
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        label="Global Partner ID"
                                        value={globalAgentNo}
                                        disabled
                                        fullWidth
                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                    />
                                </Grid>
                            </Grid>
                        </MDBox>

                    </>
                )}


                {/* -------------------- TAB 0 DEVAM -------------------- */}
                {activeTab === 0 && (
                    <>
                        {/* Tax Office - Agent Type - Sales Rep */}
                        <MDBox mt={4}>
                            <Grid container spacing={3}>
                                {/* Tax ID */}
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        type="text"
                                        label="Tax ID / Identity Number"
                                        value={taxID}
                                        onChange={(e) => setTaxID(e.target.value)}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": { height: 56 }
                                        }}
                                    />
                                </Grid>

                                {/* Tax Office */}
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        type="text"
                                        label="Tax Office"
                                        value={taxOffice}
                                        onChange={(e) => setTaxOffice(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": { height: 56 }
                                        }}
                                    />
                                </Grid>

                                {/* Global Partner Type */}
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        fullWidth
                                        options={globalAgentOptions}
                                        getOptionLabel={(o) => o.label}
                                        value={globalAgentTypes ? { label: globalAgentTypes } : null}
                                        onChange={(e, val) => setGlobalAgentTypes(val ? val.label : "")}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Global Partner Type"
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: 56,
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Sales Reps */}
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        fullWidth
                                        multiple
                                        options={salesRepOptions}
                                        getOptionLabel={(o) => o.label}
                                        value={salesRep}
                                        onChange={(e, vals) => setSalesRep(vals)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Sales Reps"
                                            />
                                        )}
                                    />
                                </Grid>

                            </Grid>
                        </MDBox>

                        <MDBox mt={4}>
                            <Grid container spacing={3}>

                                {/* Billing Address */}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        type="text"
                                        label="Billing Address"
                                        value={billingAddress}
                                        onChange={(e) => setBillingAddress(e.target.value)}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": { height: 56 }
                                        }}
                                    />
                                </Grid>

                                {/* Phone */}
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        type="text"
                                        label="Phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": { height: 56 }
                                        }}
                                    />
                                </Grid>

                                {/* Email */}
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        type="email"
                                        label="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": { height: 56 }
                                        }}
                                    />
                                </Grid>

                                {/* Website */}
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        type="url"
                                        label="Website"
                                        value={website}
                                        onChange={(e) => setWebsite(e.target.value)}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": { height: 56 }
                                        }}
                                    />
                                </Grid>

                            </Grid>
                        </MDBox>

                        {/* FINANCIAL INFO */}
                        <MDBox mt={3}>
                            <MDTypography variant="h6">Financial Information</MDTypography>

                            {financialInfoByProduct.map((block, index) => (
                                <MDBox key={index} mt={2} p={2}>
                                    <Grid container spacing={1} alignItems="center" mb={2}>
                                        <Grid item xs={12} sm={8}>
                                            <MDTypography variant="subtitle2" fontWeight="bold">
                                                Financial Terms by Product
                                            </MDTypography>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Box display="flex" justifyContent="flex-end" gap={1}>
                                                {index === financialInfoByProduct.length - 1 && (
                                                    <IconButton
                                                        color="success"
                                                        onClick={() =>
                                                            setFinancialInfoByProduct((prev) => [
                                                                ...prev,
                                                                { ...defaultFinancialBlock },
                                                            ])
                                                        }
                                                    >
                                                        <AddCircleIcon fontSize="medium" />
                                                    </IconButton>
                                                )}

                                                {financialInfoByProduct.length > 1 && (
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() =>
                                                            setFinancialInfoByProduct((prev) =>
                                                                prev.filter((_, i) => i !== index)
                                                            )
                                                        }
                                                    >
                                                        <RemoveCircleIcon fontSize="medium" />
                                                    </IconButton>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        {["road", "ocean", "air"].map((service) => (
                                            <Grid item xs={12} md={4} key={service}>
                                                <MDBox
                                                    p={2}
                                                    border="1px solid #ddd"
                                                    borderRadius="10px"
                                                    sx={{
                                                        height: "100%",
                                                        minHeight: 420,
                                                        overflowY: "auto",
                                                    }}
                                                >
                                                    <MDTypography
                                                        variant="h6"
                                                        mb={2}
                                                        textTransform="capitalize"
                                                        fontWeight="bold"
                                                    >
                                                        {service}
                                                    </MDTypography>

                                                    <TextField
                                                        fullWidth
                                                        type="number"
                                                        label="Payment Terms (days)"
                                                        value={block.financialTerms?.[service]?.paymentTerms ?? 0}
                                                        onChange={(e) =>
                                                            updateFinancialTerm(
                                                                index,
                                                                service,
                                                                "paymentTerms",
                                                                Number(e.target.value)
                                                            )
                                                        }
                                                        inputProps={{ min: 0, max: 120 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ mb: 1, "& .MuiInputBase-root": { height: 40 } }}
                                                    />

                                                    <input
                                                        type="range"
                                                        min="0"
                                                        max="120"
                                                        step="1"
                                                        value={block.financialTerms?.[service]?.paymentTerms ?? 0}
                                                        onChange={(e) =>
                                                            updateFinancialTerm(
                                                                index,
                                                                service,
                                                                "paymentTerms",
                                                                Number(e.target.value)
                                                            )
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            cursor: "pointer",
                                                            accentColor: "#1976d2",
                                                        }}
                                                    />

                                                    <MDTypography variant="caption" display="block" mb={2}>
                                                        {block.financialTerms?.[service]?.paymentTerms ?? 0} days
                                                    </MDTypography>

                                                    <TextField
                                                        fullWidth
                                                        type="number"
                                                        label="Credit Limit ($)"
                                                        value={block.financialTerms?.[service]?.creditLimit ?? 0}
                                                        onChange={(e) =>
                                                            updateFinancialTerm(
                                                                index,
                                                                service,
                                                                "creditLimit",
                                                                Number(e.target.value)
                                                            )
                                                        }
                                                        inputProps={{ min: 0, max: 200000 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ mb: 1, "& .MuiInputBase-root": { height: 40 } }}
                                                    />

                                                    <input
                                                        type="range"
                                                        min="0"
                                                        max="200000"
                                                        step="1000"
                                                        value={block.financialTerms?.[service]?.creditLimit ?? 0}
                                                        onChange={(e) =>
                                                            updateFinancialTerm(
                                                                index,
                                                                service,
                                                                "creditLimit",
                                                                Number(e.target.value)
                                                            )
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            cursor: "pointer",
                                                            accentColor: "green",
                                                        }}
                                                    />

                                                    <MDTypography variant="caption" display="block" mb={2}>
                                                        {(block.financialTerms?.[service]?.creditLimit ?? 0).toLocaleString()} $
                                                    </MDTypography>

                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Currency"
                                                        value={block.financialTerms?.[service]?.currency ?? "USD"}
                                                        onChange={(e) =>
                                                            updateFinancialTerm(
                                                                index,
                                                                service,
                                                                "currency",
                                                                e.target.value
                                                            )
                                                        }
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </MDBox>
                                            </Grid>
                                        ))}
                                    </Grid>

                                    <MDBox mt={3}>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12}>
                                                <MDTypography variant="subtitle2" fontWeight="bold" mt={2}>
                                                    Bank Information
                                                </MDTypography>
                                            </Grid>

                                            {(block.bankDetails?.length
                                                    ? block.bankDetails
                                                    : [{ bankName: "", swiftCode: "", iban: "", currency: "USD" }]
                                            ).map((bank, bankIndex) => (
                                                <React.Fragment key={bankIndex}>
                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            fullWidth
                                                            label="Bank Name"
                                                            value={bank.bankName || ""}
                                                            onChange={(e) =>
                                                                updateBankDetail(
                                                                    index,
                                                                    bankIndex,
                                                                    "bankName",
                                                                    e.target.value.toUpperCase()
                                                                )
                                                            }
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            fullWidth
                                                            label="Swift Code"
                                                            value={bank.swiftCode || ""}
                                                            onChange={(e) =>
                                                                updateBankDetail(
                                                                    index,
                                                                    bankIndex,
                                                                    "swiftCode",
                                                                    e.target.value.toUpperCase()
                                                                )
                                                            }
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            fullWidth
                                                            label="IBAN"
                                                            value={bank.iban || ""}
                                                            onChange={(e) =>
                                                                updateBankDetail(
                                                                    index,
                                                                    bankIndex,
                                                                    "iban",
                                                                    e.target.value.toUpperCase()
                                                                )
                                                            }
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={2}>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            label="Currency"
                                                            value={bank.currency || "USD"}
                                                            onChange={(e) =>
                                                                updateBankDetail(
                                                                    index,
                                                                    bankIndex,
                                                                    "currency",
                                                                    e.target.value
                                                                )
                                                            }
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        >
                                                            <MenuItem value="USD">USD</MenuItem>
                                                            <MenuItem value="EUR">EUR</MenuItem>
                                                            <MenuItem value="TRY">TRY</MenuItem>
                                                            <MenuItem value="GBP">GBP</MenuItem>
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item xs={12} md={1} display="flex" justifyContent="center">
                                                        {bankIndex === (block.bankDetails?.length || 1) - 1 && (
                                                            <AddRowButton onClick={() => addBankDetail(index)} tooltip="Add bank account" />
                                                        )}

                                                        {(block.bankDetails?.length || 1) > 1 && (
                                                            <RemoveRowButton onClick={() => removeBankDetail(index, bankIndex)} tooltip="Remove bank account" />
                                                        )}
                                                    </Grid>
                                                </React.Fragment>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                </MDBox>
                            ))}
                        </MDBox>




                        {/* -------------------- Global Partner GROUP -------------------- */}
                        <MDBox mt={5}>
                            <MDTypography variant="h6">Global Partner Group</MDTypography>

                            <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        multiple
                                        options={[
                                            { label: "Global Forwarder" },
                                            { label: "Regional Forwarder" },
                                            { label: "Local/Niche Agent" },
                                        ]}
                                        value={byGeneralLocationAndCoverage.map((x) => ({ label: x }))}
                                        onChange={(e, v) => setByGeneralLocationAndCoverage(v.map((i) => i.label))}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="By General Location & Coverage"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        multiple
                                        options={[
                                            { label: "Exclusive Partner" },
                                            { label: "JV Partner" },
                                            { label: "Strategic Partner" },
                                            { label: "Ad-hoc Partner" },
                                            { label: "Standard Partner" }
                                        ]}
                                        value={byTypeOfCollaboration.map((x) => ({ label: x }))}
                                        onChange={(e, v) => setByTypeOfCollaboration(v.map((i) => i.label))}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="By Type of Collaboration"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>

                            <MDBox mt={4}>
                                <MDTypography variant="h6">References</MDTypography>

                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            fullWidth
                                            options={[
                                                { label: "Sales Team", value: "Sales Team" },
                                                { label: "Management", value: "Management" },
                                                { label: "External", value: "External" },
                                            ]}
                                            value={
                                                referenceSource
                                                    ? {
                                                        label: referenceSource,
                                                        value: referenceSource,
                                                    }
                                                    : null
                                            }
                                            isOptionEqualToValue={(option, value) =>
                                                option.value === value.value
                                            }
                                            onChange={(event, newValue) => {
                                                const value = newValue?.value || "";

                                                setReferenceSource(value);
                                                setReferencePerson("");
                                                setExternalType("");
                                                setExternalPersonName("");
                                                setExternalForwardTo(null);
                                                setExternalCompany(null);
                                                setIsHouseAccountRef(false);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="References (Who suggested this firm?)"
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            height: 56,
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {referenceSource === "Sales Team" && (
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                fullWidth
                                                options={salesTeamPeople.map((item) => ({
                                                    label: item,
                                                    value: item,
                                                }))}
                                                value={
                                                    referencePerson
                                                        ? { label: referencePerson, value: referencePerson }
                                                        : null
                                                }
                                                onChange={(e, v) =>
                                                    setReferencePerson(v?.value || "")
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Sales Team Person"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    )}

                                    {referenceSource === "Management" && (
                                        <>
                                            <Grid item xs={12} md={3}>
                                                <Autocomplete
                                                    fullWidth
                                                    options={managementPeople.map((item) => ({
                                                        label: item,
                                                        value: item,
                                                    }))}
                                                    value={
                                                        referencePerson
                                                            ? { label: referencePerson, value: referencePerson }
                                                            : null
                                                    }
                                                    onChange={(e, v) =>
                                                        setReferencePerson(v?.value || "")
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Management Person"
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={isHouseAccountRef}
                                                            onChange={(e) => setIsHouseAccountRef(e.target.checked)}
                                                        />
                                                    }
                                                    label="House Account"
                                                />
                                            </Grid>
                                        </>
                                    )}

                                    {referenceSource === "External" && (
                                        <>
                                            <Grid item xs={12} md={3}>
                                                <Autocomplete
                                                    fullWidth
                                                    options={[
                                                        { label: "In Person", value: "In Person" },
                                                        { label: "Company", value: "Company" },
                                                    ]}
                                                    value={
                                                        externalType
                                                            ? { label: externalType, value: externalType }
                                                            : null
                                                    }
                                                    onChange={(e, v) => {
                                                        setExternalType(v?.value || "");
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="External Type"
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {externalType === "In Person" && (
                                                <>
                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            fullWidth
                                                            label="Name Surname"
                                                            value={externalPersonName}
                                                            onChange={(e) => setExternalPersonName(e.target.value)}
                                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={3}>
                                                        <Autocomplete
                                                            fullWidth
                                                            options={salesRepOptions}
                                                            getOptionLabel={(o) => o?.label || ""}
                                                            value={externalForwardTo}
                                                            onChange={(e, v) => setExternalForwardTo(v)}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Forwarded to (Sales Rep)"
                                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </>
                                            )}

                                            {externalType === "Company" && (
                                                <Grid item xs={12} md={3}>
                                                    <Autocomplete
                                                        fullWidth
                                                        loading={companyLoading}
                                                        options={companyOptions}
                                                        getOptionLabel={(o) => o?.label || ""}
                                                        value={externalCompany}
                                                        onChange={(e, v) => setExternalCompany(v)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Company"
                                                                sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )}
                                        </>
                                    )}                                </Grid>
                            </MDBox>

                        </MDBox>

                        <Box mt={4} display="flex" justifyContent="flex-end">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setActiveTab(1)}
                                sx={{ color: "#fff" }}
                            >
                                Next ➡️
                            </Button>
                        </Box>

                    </>
                )}



                {/* -------------------- CONTACT LIST (TAB 1) -------------------- */}
                {activeTab === 1 && (
                    <>

                        {/* Top Management CONTACTS ----------------------------------------------- */}
                        <MDBox mt={5}>
                            <MDTypography variant="h6">Top Management Contact Information</MDTypography>
                        </MDBox>

                        <Grid container spacing={2} alignItems="center">
                            {financeRepresentatives.map((rep, index) => (
                                <React.Fragment key={index}>

                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Name"
                                            value={rep.name}
                                            onChange={(e) => updateFinanceRepresentative(index, "name", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Phone"
                                            value={rep.phone}
                                            onChange={(e) => updateFinanceRepresentative(index, "phone", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Email"
                                            value={rep.email}
                                            onChange={(e) => updateFinanceRepresentative(index, "email", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Title"
                                            value={rep.title}
                                            onChange={(e) => updateFinanceRepresentative(index, "title", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            multiple
                                            options={departmentOptions}
                                            value={rep.department}
                                            onChange={(event, newValue) =>
                                                updateFinanceRepresentative(index, "department", newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Department"
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            minHeight: 56,
                                                            alignItems: "center",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            options={countryOptions}
                                            getOptionLabel={(o) => o.label}
                                            isOptionEqualToValue={(a, b) => a?.label === b?.label}
                                            value={
                                                rep.country
                                                    ? (countryOptions.find((c) => c.label === rep.country) || { label: rep.country })
                                                    : null
                                            }
                                            onChange={async (_e, v) => {
                                                const nextCountry = v?.label || "";
                                                updateFinanceRepresentative(index, "country", nextCountry);
                                                updateFinanceRepresentative(index, "city", "");
                                                if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Country"
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <Autocomplete
                                            freeSolo
                                            disabled={!rep.country}
                                            loading={!!rep.country && !!repCityLoadingMap?.[rep.country]}
                                            options={rep.country ? (repCityOptionsMap?.[rep.country] || []) : []}
                                            value={rep.city || ""}
                                            onChange={(_e, v) => updateFinanceRepresentative(index, "city", v || "")}
                                            onInputChange={(_e, v) => updateFinanceRepresentative(index, "city", v || "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="City"
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>


                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                        {index === financeRepresentatives.length - 1 && (
                                            <AddRowButton onClick={addFinanceRepresentative} tooltip="Add finance representative" />
                                        )}
                                        {financeRepresentatives.length > 1 && (
                                            <RemoveRowButton onClick={() => removeFinanceRepresentative(index)} tooltip="Remove finance representative" />
                                        )}
                                    </Grid>

                                </React.Fragment>
                            ))}
                        </Grid>


                        {/* PRICING CONTACTS ------------------------------------------------ */}
                        <MDBox mt={4}>
                            <MDTypography variant="h6">Pricing Contact Information</MDTypography>
                        </MDBox>

                        <Grid container spacing={2} alignItems="center">
                            {pricingRepresentatives.map((rep, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Name"
                                            value={rep.name}
                                            onChange={(e) => updatePricingRepresentative(index, "name", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    {/* Phone */}
                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Phone"
                                            value={rep.phone}
                                            onChange={(e) => updatePricingRepresentative(index, "phone", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    {/* Email */}
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Email"
                                            value={rep.email}
                                            onChange={(e) => updatePricingRepresentative(index, "email", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    {/* Title */}
                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Title"
                                            value={rep.title}
                                            onChange={(e) => updatePricingRepresentative(index, "title", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    {/* Department */}
                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            multiple
                                            options={departmentOptions}
                                            value={rep.department}
                                            onChange={(event, newValue) =>
                                                updatePricingRepresentative(index, "department", newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Department"
                                                    fullWidth
                                                />
                                            )}
                                        />
                                    </Grid>


                                    {/* Country */}
                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            options={countryOptions}
                                            getOptionLabel={(o) => o.label}
                                            isOptionEqualToValue={(a, b) => a?.label === b?.label}
                                            value={rep.country ? (countryOptions.find((c) => c.label === rep.country) || { label: rep.country }) : null}
                                            onChange={async (_e, v) => {
                                                const nextCountry = v?.label || "";
                                                updatePricingRepresentative(index, "country", nextCountry);
                                                updatePricingRepresentative(index, "city", "");
                                                if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Country"
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <Autocomplete
                                            freeSolo
                                            disabled={!rep.country}
                                            loading={!!rep.country && !!repCityLoadingMap[rep.country]}
                                            options={rep.country ? (repCityOptionsMap[rep.country] || []) : []}
                                            value={rep.city || ""}
                                            onChange={(_e, v) => updatePricingRepresentative(index, "city", v || "")}
                                            onInputChange={(_e, v) => updatePricingRepresentative(index, "city", v || "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="City"
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>


                                    {/* Add / Remove */}
                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                        {index === pricingRepresentatives.length - 1 && (
                                            <AddRowButton onClick={addPricingRepresentative} tooltip="Add pricing representative" />
                                        )}
                                        {pricingRepresentatives.length > 1 && (
                                            <RemoveRowButton onClick={() => removePricingRepresentative(index)} tooltip="Remove pricing representative" />
                                        )}
                                    </Grid>

                                </React.Fragment>
                            ))}
                        </Grid>

                        {/* SALES CONTACTS ------------------------------------------------ */}
                        <MDBox mt={5}>
                            <MDTypography variant="h6">Sales Contact Information</MDTypography>
                        </MDBox>

                        <Grid container spacing={2} alignItems="center">
                            {representatives.map((rep, index) => (
                                <React.Fragment key={index}>

                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Name"
                                            value={rep.name}
                                            onChange={(e) => updateRepresentative(index, "name", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Phone"
                                            value={rep.phone}
                                            onChange={(e) => updateRepresentative(index, "phone", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Email"
                                            value={rep.email}
                                            onChange={(e) => updateRepresentative(index, "email", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Title"
                                            value={rep.title}
                                            onChange={(e) => updateRepresentative(index, "title", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            multiple
                                            options={departmentOptions}
                                            value={rep.department}
                                            onChange={(event, newValue) =>
                                                updateRepresentative(index, "department", newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Department"
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            minHeight: 56,
                                                            alignItems: "center",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            options={countryOptions}
                                            getOptionLabel={(o) => o.label}
                                            isOptionEqualToValue={(a, b) => a?.label === b?.label}
                                            value={
                                                rep.country
                                                    ? (countryOptions.find((c) => c.label === rep.country) || { label: rep.country })
                                                    : null
                                            }
                                            onChange={async (_e, v) => {
                                                const nextCountry = v?.label || "";
                                                updateRepresentative(index, "country", nextCountry);
                                                updateRepresentative(index, "city", "");
                                                if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Country"
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <Autocomplete
                                            freeSolo
                                            disabled={!rep.country}
                                            loading={!!rep.country && !!repCityLoadingMap?.[rep.country]}
                                            options={rep.country ? (repCityOptionsMap?.[rep.country] || []) : []}
                                            value={rep.city || ""}
                                            onChange={(_e, v) => updateRepresentative(index, "city", v || "")}
                                            onInputChange={(_e, v) => updateRepresentative(index, "city", v || "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="City"
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>


                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                        {index === representatives.length - 1 && (
                                            <AddRowButton onClick={addRepresentative} tooltip="Add representative" />
                                        )}
                                        {representatives.length > 1 && (
                                            <RemoveRowButton onClick={() => removeRepresentative(index)} tooltip="Remove representative" />
                                        )}
                                    </Grid>

                                </React.Fragment>
                            ))}
                        </Grid>



                        {/* OPERATION CONTACTS --------------------------------------------- */}
                        <MDBox mt={5}>
                            <MDTypography variant="h6">Operation Contact Information</MDTypography>
                        </MDBox>

                        <Grid container spacing={2} alignItems="center">
                            {operationRepresentatives.map((rep, index) => (
                                <React.Fragment key={index}>

                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Name"
                                            value={rep.name}
                                            onChange={(e) => updateOperationRepresentative(index, "name", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Phone"
                                            value={rep.phone}
                                            onChange={(e) => updateOperationRepresentative(index, "phone", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Email"
                                            value={rep.email}
                                            onChange={(e) => updateOperationRepresentative(index, "email", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <TextField
                                            label="Title"
                                            value={rep.title}
                                            onChange={(e) => updateOperationRepresentative(index, "title", e.target.value)}
                                            fullWidth
                                            sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            multiple
                                            options={departmentOptions}
                                            value={rep.department}
                                            onChange={(event, newValue) =>
                                                updateOperationRepresentative(index, "department", newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Department"
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            minHeight: 56,
                                                            alignItems: "center",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            options={countryOptions}
                                            getOptionLabel={(o) => o.label}
                                            isOptionEqualToValue={(a, b) => a?.label === b?.label}
                                            value={
                                                rep.country
                                                    ? (countryOptions.find((c) => c.label === rep.country) || { label: rep.country })
                                                    : null
                                            }
                                            onChange={async (_e, v) => {
                                                const nextCountry = v?.label || "";
                                                updateOperationRepresentative(index, "country", nextCountry);
                                                updateOperationRepresentative(index, "city", "");
                                                if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Country"
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1}>
                                        <Autocomplete
                                            freeSolo
                                            disabled={!rep.country}
                                            loading={!!rep.country && !!repCityLoadingMap?.[rep.country]}
                                            options={rep.country ? (repCityOptionsMap?.[rep.country] || []) : []}
                                            value={rep.city || ""}
                                            onChange={(_e, v) => updateOperationRepresentative(index, "city", v || "")}
                                            onInputChange={(_e, v) => updateOperationRepresentative(index, "city", v || "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="City"
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                />
                                            )}
                                        />
                                    </Grid>


                                    <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                        {index === operationRepresentatives.length - 1 && (
                                            <AddRowButton onClick={addOperationRepresentative} tooltip="Add operation representative" />
                                        )}
                                        {operationRepresentatives.length > 1 && (
                                            <RemoveRowButton onClick={() => removeOperationRepresentative(index)} tooltip="Remove operation representative" />
                                        )}
                                    </Grid>

                                </React.Fragment>
                            ))}
                        </Grid>
                        <MDBox mt={5}>
                            <MDTypography variant="h6">Notes & Additional Information</MDTypography>
                        </MDBox>

                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Special Notes"
                                    value={specialNotes}
                                    onChange={(e) => setSpecialNotes(e.target.value)}
                                    fullWidth
                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Transaction History Notes"
                                    value={transactionNotes}
                                    onChange={(e) => setTransactionNotes(e.target.value)}
                                    fullWidth
                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    label="Complaint / Support History"
                                    value={complaintHistory}
                                    onChange={(e) => setComplaintHistory(e.target.value)}
                                    fullWidth
                                    sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                />
                            </Grid>

                        </Grid>
                        <Box
                            mt={6}
                            mb={3}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                onClick={() => setActiveTab(0)}
                                sx={{
                                    backgroundColor: "#ff7400",
                                    color: "#ffffff",
                                    fontWeight: "bold",
                                    "&:hover": { backgroundColor: "#ff7400" },
                                }}
                            >
                                ⬅️ Back
                            </Button>

                            <Button
                                variant="contained"
                                onClick={submitHandler}
                                sx={{
                                    backgroundColor: "#0B1F3A",
                                    color: "#FFFFFF",
                                    fontWeight: "bold",
                                    "&:hover": { backgroundColor: "#43a047" },
                                }}
                            >
                                {isEditing ? "Update Global Partner" : "Create Global Partner"}
                            </Button>
                        </Box>

                    </>
                )}

            </MDBox>
            </ReadOnlyFieldset>


            <br /><br />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                    variant="filled"
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );

    return isModal ? (
        formContent
    ) : (
        <DashboardLayout>
            <DashboardNavbar />
            {formContent}
            <Footer />
        </DashboardLayout>
    );
};

export default CreateGlobalAgent;
